/* eslint-disable max-len */
export const TINYMCE_DEFAULTS = {
    plugins: [
        "advlist",
        "anchor",
        "autolink",
        "autosave",
        "charmap",
        "code",
        "directionality",
        "emoticons",
        "image",
        "insertdatetime",
        "link",
        "lists",
        "media",
        "nonbreaking",
        "preview",
        "pagebreak",
        "searchreplace",
        "table",
        "visualblocks",
        "visualchars",
        "wordcount"
    ],
    indent_use_margin: true,
    autosave_ask_before_unload: false,
    convert_urls: false,
    browser_spellcheck: true,
    urlconverter_callback: function (url /*, node, on_save, name*/) {
        const cleanUrl = url.trim();
        // Clean up form_link tags that are used as anchor tag targets
        if (cleanUrl.startsWith("{") && cleanUrl.endsWith("}")) {
            url = url.replaceAll("%20", " ");
        }
        return url;
    },
    height: 500,

    // The following security settings are enabled by default in TinyMCE 7. Waiting to upgrade to v7 because of the license change.
    convert_unsafe_embeds: true, // converts unsafe embed elements to more restrictive alternatives, addresses SNYK-JS-TINYMCE-6501605
    sandbox_iframes: true, // adds sandbox attribute to iframes, addresses SNYK-JS-TINYMCE-6501006

    /**
     * In TinyMCE 6.x, the default for style colors is the rgb format. Hex colors are the industry standard, and are standard in TinyMCE 5.x and
     * TinyMCE 7.x. This setting forces the hex color format for the style colors, but is currently commented because of the following bug:
     * https://github.com/tinymce/tinymce/issues/9391
     */
    // force_hex_color = "always"

    toolbar1:
        "bold italic underline strikethrough | subscript superscript | alignleft aligncenter alignright alignjustify | outdent indent blockquote | bullist numlist | cut copy paste | searchreplace | undo redo restoredraft | print fullscreen code preview",
    toolbar2:
        "blocks fontfamily fontsize | forecolor backcolor | removeformat | table | hr | charmap | link unlink image",

    // default context menu (as of 07/2024) with custom spellcheck plugin
    contextmenu: "link linkchecker image editimage permanentpen table browserspellcheckreminder",

    external_plugins: {
        browserspellcheckreminder: "../../TinyMCE/SpellcheckReminderPlugin/SpellcheckReminderPlugin.js"
    },

    menubar: false
};
